import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const CreateOrder = lazy(() => import('../../container/purchases/CreateOrder'));
const PurchasesList = lazy(() => import('../../container/purchases'));
const OrderDetailsTab = lazy(() => import('../../container/purchases/components/OrderDetailsTab'));
const NotFound = lazy(() => import('../../container/pages/404'));
// const CardCategoriesSales = lazy(() => import('../../container/sales/CardsCategoriesSales'));

function PurchasesRoute() {
  return (
    <Routes>
      <Route path="/" element={<PurchasesList />} />
      <Route path="/create-order" element={<CreateOrder />} />
      <Route path="/:id/*" element={<OrderDetailsTab />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default PurchasesRoute;
